import { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { toggleSidebarTrue } from "../../redux/slices/sidebarStatus";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import bprLogoBlack from '../../assets/img/logo/logobprblack.png';
import bprLogoWhite from '../../assets/img/logo/logobprwhite.png';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const dispatch = useDispatch();
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const handleSidebar = () => {
        dispatch(toggleSidebarTrue());
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 1);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleDropdown = (dropdownOpen: any) => {
        setActiveDropdown((prev) => (prev === dropdownOpen ? null : dropdownOpen));
    };

    return (
        <motion.nav
            initial={{ opacity: 1, y: 0 }}
            animate={{ opacity: 1, y: isScrolled ? -10 : 0 }}
            transition={{ duration: 0.3 }}
            className={`border-gray-200 sticky top-0 z-30 transition-colors duration-300 ${isScrolled ? 'bg-bprDarkBlue bg-opacity-95' : 'bg-white'}`}
        >
            <div className="max-w-screen-2xl flex flex-wrap items-center justify-between mx-auto p-4 sm:mx-10 lg:mx-10 xl:mx-auto 2xl:px-14 ">
                <Link to="/" className="flex items-center space-x-3">
                    <LazyLoadImage
                        src={!isScrolled ? bprLogoBlack : bprLogoWhite}
                        alt="bpr logo"
                        width="270"
                        height="87"
                        effect="blur"
                        className='w-44 md:w-[270px]'
                    />
                </Link>

                <button onClick={handleSidebar} className="inline-flex items-center p-2 w-10 h-10 xl:hidden text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none">
                    <span className="sr-only">Open main menu</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 17 14">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M1 1h15M1 7h15M1 13h15" />
                    </svg>
                </button>

                <div className="hidden xl:block">
                    <ul className="flex space-x-8 text-sm font-poppinsRegular p-2">
                        <li>
                            <Link to="/" className={`py-2 px-3 block ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} hover:text-bprBlue`}>Beranda</Link>
                        </li>

                        <li className="relative">
                            <button onClick={() => toggleDropdown('perusahaan')} className={`flex items-center py-2 px-3 ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} hover:text-bprBlue`}>
                                Perusahaan
                                <svg className="w-3 h-3 ml-2" fill="none" stroke="currentColor" viewBox="0 0 10 6">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l4 4 4-4" />
                                </svg>
                            </button>
                            {activeDropdown === 'perusahaan' && (
                                <div className="absolute top-full mt-2 bg-white border border-gray-200 shadow-lg rounded-md z-20 min-w-[300px] dark:bg-gray-800">
                                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-300">
                                        <li>
                                            <Link to="/tentang-kami" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Tentang Kami</Link>
                                        </li>
                                        <li>
                                            <Link to="/produk" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Produk</Link>
                                        </li>
                                        <li>
                                            <Link to="/galeri" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Galeri</Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </li>
                        <li className="relative">
                            <button onClick={() => toggleDropdown('penawaran-terkini')} className={`flex items-center py-2 px-3 ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} hover:text-bprBlue`}>
                                Penawaran
                                <svg className="w-3 h-3 ml-2" fill="none" stroke="currentColor" viewBox="0 0 10 6">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l4 4 4-4" />
                                </svg>
                            </button>
                            {activeDropdown === 'penawaran-terkini' && (
                                <div className="absolute top-full mt-2 bg-white border border-gray-200 shadow-lg rounded-md z-20 min-w-[180px] dark:bg-gray-800">
                                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-300">
                                        <li>
                                            <Link to="/penawaran-terkini" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Penawaran Terkini</Link>
                                        </li>
                                        <li>
                                            <Link to="/lelang" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Lelang</Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </li>
                        <li className="relative">
                            <button onClick={() => toggleDropdown('dokumen')} className={`flex items-center py-2 px-3 ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} hover:text-bprBlue`}>
                                Dokumen
                                <svg className="w-3 h-3 ml-2" fill="none" stroke="currentColor" viewBox="0 0 10 6">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l4 4 4-4" />
                                </svg>
                            </button>
                            {activeDropdown === 'dokumen' && (
                                <div className="absolute top-full mt-2 bg-white border border-gray-200 shadow-lg rounded-md z-20 min-w-[300px] dark:bg-gray-800">
                                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-300">
                                        <li>
                                            <Link to="/dokumen/laporan-publikasi" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Laporan Publikasi</Link>
                                        </li>
                                        <li>
                                            <Link to="/dokumen/kebijakan-keamanan-informasi" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Kebijakan Keamanan Informasi</Link>
                                        </li>
                                        <li>
                                            <Link to="/dokumen/dokumen-lainnya" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">Dokumen Lainnya</Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </li>
                        <li>
                            <Link to="/informasi-dan-berita" className={`block py-2 px-3 ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} rounded hover:text-bprBlue`}>Informasi & Berita</Link>
                        </li>
                        <li>
                            <Link to="/karir" className={`block py-2 px-3 ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} rounded hover:text-bprBlue`}>Karir</Link>
                        </li>
                        <li>
                            <Link to="/media-edukasi" className={`block py-2 px-3 ${isScrolled ? 'text-white' : 'text-bprDarkBlue'} rounded hover:text-bprBlue`}>Media Edukasi</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </motion.nav>
    );
}
